// Generated from FIFA_World_Cup_2026_Complete_Match_Schedule.xlsx
export const scheduleMatches = [
  {
    "matchNo": 1,
    "date": "2026-06-11",
    "day": "Thursday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "A",
    "teamA": "Mexico",
    "teamB": "South Africa",
    "city": "Mexico City",
    "country": "Mexico",
    "stadium": "Estadio Azteca",
    "region": "Central Region",
    "result": "Mexico 2-0 South Africa"
  },
  {
    "matchNo": 2,
    "date": "2026-06-11",
    "day": "Thursday",
    "kickoffET": "22:00",
    "stage": "Group Stage",
    "group": "A",
    "teamA": "Korea Republic",
    "teamB": "Czechia",
    "city": "Guadalajara",
    "country": "Mexico",
    "stadium": "Estadio Akron",
    "region": "Central Region",
    "result": "Korea Republic 2-1 Czechia"
  },
  {
    "matchNo": 3,
    "date": "2026-06-12",
    "day": "Friday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "B",
    "teamA": "Canada",
    "teamB": "Bosnia and Herzegovina",
    "city": "Toronto",
    "country": "Canada",
    "stadium": "BMO Field",
    "region": "Eastern Region",
    "result": "Canada 1-1 Bosnia & Herzegovina"
  },
  {
    "matchNo": 4,
    "date": "2026-06-12",
    "day": "Friday",
    "kickoffET": "21:00",
    "stage": "Group Stage",
    "group": "D",
    "teamA": "USA",
    "teamB": "Paraguay",
    "city": "Los Angeles",
    "country": "United States",
    "stadium": "SoFi Stadium",
    "region": "Western Region",
    "result": "USA 4-1 Paraguay"
  },
  {
    "matchNo": 5,
    "date": "2026-06-13",
    "day": "Saturday",
    "kickoffET": "21:00",
    "stage": "Group Stage",
    "group": "C",
    "teamA": "Haiti",
    "teamB": "Scotland",
    "city": "Boston",
    "country": "United States",
    "stadium": "Gillette Stadium",
    "region": "Eastern Region",
    "result": "Haiti 0-1 Scotland"
  },
  {
    "matchNo": 6,
    "date": "2026-06-14",
    "day": "Sunday",
    "kickoffET": "00:00",
    "stage": "Group Stage",
    "group": "D",
    "teamA": "Australia",
    "teamB": "Türkiye",
    "city": "Vancouver",
    "country": "Canada",
    "stadium": "BC Place",
    "region": "Western Region",
    "result": "Australia 2-0 Türkiye"
  },
  {
    "matchNo": 7,
    "date": "2026-06-13",
    "day": "Saturday",
    "kickoffET": "18:00",
    "stage": "Group Stage",
    "group": "C",
    "teamA": "Brazil",
    "teamB": "Morocco",
    "city": "New York New Jersey",
    "country": "United States",
    "stadium": "MetLife Stadium",
    "region": "Eastern Region",
    "result": "Brazil 1-1 Morocco"
  },
  {
    "matchNo": 8,
    "date": "2026-06-13",
    "day": "Saturday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "B",
    "teamA": "Qatar",
    "teamB": "Switzerland",
    "city": "San Francisco Bay Area",
    "country": "United States",
    "stadium": "Levi's Stadium",
    "region": "Western Region",
    "result": "Qatar 1-1 Switzerland"
  },
  {
    "matchNo": 9,
    "date": "2026-06-14",
    "day": "Sunday",
    "kickoffET": "19:00",
    "stage": "Group Stage",
    "group": "E",
    "teamA": "Côte d’Ivoire",
    "teamB": "Ecuador",
    "city": "Philadelphia",
    "country": "United States",
    "stadium": "Lincoln Financial Field",
    "region": "Eastern Region",
    "result": "Côte d'Ivoire 1-0 Ecuador"
  },
  {
    "matchNo": 10,
    "date": "2026-06-14",
    "day": "Sunday",
    "kickoffET": "13:00",
    "stage": "Group Stage",
    "group": "E",
    "teamA": "Germany",
    "teamB": "Curaçao",
    "city": "Houston",
    "country": "United States",
    "stadium": "NRG Stadium",
    "region": "Central Region",
    "result": "Germany 7-1 Curaçao"
  },
  {
    "matchNo": 11,
    "date": "2026-06-14",
    "day": "Sunday",
    "kickoffET": "16:00",
    "stage": "Group Stage",
    "group": "F",
    "teamA": "Netherlands",
    "teamB": "Japan",
    "city": "Dallas",
    "country": "United States",
    "stadium": "AT&T Stadium",
    "region": "Central Region",
    "result": "Netherlands 2-2 Japan"
  },
  {
    "matchNo": 12,
    "date": "2026-06-14",
    "day": "Sunday",
    "kickoffET": "22:00",
    "stage": "Group Stage",
    "group": "F",
    "teamA": "Sweden",
    "teamB": "Tunisia",
    "city": "Monterrey",
    "country": "Mexico",
    "stadium": "Estadio BBVA",
    "region": "Central Region",
    "result": "Sweden 5-1 Tunisia"
  },
  {
    "matchNo": 13,
    "date": "2026-06-15",
    "day": "Monday",
    "kickoffET": "18:00",
    "stage": "Group Stage",
    "group": "H",
    "teamA": "Saudi Arabia",
    "teamB": "Uruguay",
    "city": "Miami",
    "country": "United States",
    "stadium": "Hard Rock Stadium",
    "region": "Eastern Region",
    "result": "Saudi Arabia 1-1 Uruguay"
  },
  {
    "matchNo": 14,
    "date": "2026-06-15",
    "day": "Monday",
    "kickoffET": "12:00",
    "stage": "Group Stage",
    "group": "H",
    "teamA": "Spain",
    "teamB": "Cabo Verde",
    "city": "Atlanta",
    "country": "United States",
    "stadium": "Mercedes-Benz Stadium",
    "region": "Eastern Region",
    "result": "Spain 0-0 Cabo Verde"
  },
  {
    "matchNo": 15,
    "date": "2026-06-15",
    "day": "Monday",
    "kickoffET": "21:00",
    "stage": "Group Stage",
    "group": "G",
    "teamA": "IR Iran",
    "teamB": "New Zealand",
    "city": "Los Angeles",
    "country": "United States",
    "stadium": "SoFi Stadium",
    "region": "Western Region",
    "result": "IR Iran 2-2 New Zealand"
  },
  {
    "matchNo": 16,
    "date": "2026-06-15",
    "day": "Monday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "G",
    "teamA": "Belgium",
    "teamB": "Egypt",
    "city": "Seattle",
    "country": "United States",
    "stadium": "Lumen Field",
    "region": "Western Region",
    "result": "Belgium 1-1 Egypt"
  },
  {
    "matchNo": 17,
    "date": "2026-06-16",
    "day": "Tuesday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "I",
    "teamA": "France",
    "teamB": "Senegal",
    "city": "New York New Jersey",
    "country": "United States",
    "stadium": "MetLife Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 18,
    "date": "2026-06-16",
    "day": "Tuesday",
    "kickoffET": "18:00",
    "stage": "Group Stage",
    "group": "I",
    "teamA": "Iraq",
    "teamB": "Norway",
    "city": "Boston",
    "country": "United States",
    "stadium": "Gillette Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 19,
    "date": "2026-06-16",
    "day": "Tuesday",
    "kickoffET": "21:00",
    "stage": "Group Stage",
    "group": "J",
    "teamA": "Argentina",
    "teamB": "Algeria",
    "city": "Kansas City",
    "country": "United States",
    "stadium": "Arrowhead Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 20,
    "date": "2026-06-17",
    "day": "Wednesday",
    "kickoffET": "00:00",
    "stage": "Group Stage",
    "group": "J",
    "teamA": "Austria",
    "teamB": "Jordan",
    "city": "San Francisco Bay Area",
    "country": "United States",
    "stadium": "Levi's Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 21,
    "date": "2026-06-17",
    "day": "Wednesday",
    "kickoffET": "19:00",
    "stage": "Group Stage",
    "group": "L",
    "teamA": "Ghana",
    "teamB": "Panama",
    "city": "Toronto",
    "country": "Canada",
    "stadium": "BMO Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 22,
    "date": "2026-06-17",
    "day": "Wednesday",
    "kickoffET": "16:00",
    "stage": "Group Stage",
    "group": "L",
    "teamA": "England",
    "teamB": "Croatia",
    "city": "Dallas",
    "country": "United States",
    "stadium": "AT&T Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 23,
    "date": "2026-06-17",
    "day": "Wednesday",
    "kickoffET": "13:00",
    "stage": "Group Stage",
    "group": "K",
    "teamA": "Portugal",
    "teamB": "Congo DR",
    "city": "Houston",
    "country": "United States",
    "stadium": "NRG Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 24,
    "date": "2026-06-17",
    "day": "Wednesday",
    "kickoffET": "22:00",
    "stage": "Group Stage",
    "group": "K",
    "teamA": "Uzbekistan",
    "teamB": "Colombia",
    "city": "Mexico City",
    "country": "Mexico",
    "stadium": "Estadio Azteca",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 25,
    "date": "2026-06-18",
    "day": "Thursday",
    "kickoffET": "12:00",
    "stage": "Group Stage",
    "group": "A",
    "teamA": "Czechia",
    "teamB": "South Africa",
    "city": "Atlanta",
    "country": "United States",
    "stadium": "Mercedes-Benz Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 26,
    "date": "2026-06-18",
    "day": "Thursday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "B",
    "teamA": "Switzerland",
    "teamB": "Bosnia and Herzegovina",
    "city": "Los Angeles",
    "country": "United States",
    "stadium": "SoFi Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 27,
    "date": "2026-06-18",
    "day": "Thursday",
    "kickoffET": "18:00",
    "stage": "Group Stage",
    "group": "B",
    "teamA": "Canada",
    "teamB": "Qatar",
    "city": "Vancouver",
    "country": "Canada",
    "stadium": "BC Place",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 28,
    "date": "2026-06-18",
    "day": "Thursday",
    "kickoffET": "21:00",
    "stage": "Group Stage",
    "group": "A",
    "teamA": "Mexico",
    "teamB": "Korea Republic",
    "city": "Guadalajara",
    "country": "Mexico",
    "stadium": "Estadio Akron",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 29,
    "date": "2026-06-19",
    "day": "Friday",
    "kickoffET": "20:30",
    "stage": "Group Stage",
    "group": "C",
    "teamA": "Brazil",
    "teamB": "Haiti",
    "city": "Philadelphia",
    "country": "United States",
    "stadium": "Lincoln Financial Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 30,
    "date": "2026-06-19",
    "day": "Friday",
    "kickoffET": "18:00",
    "stage": "Group Stage",
    "group": "C",
    "teamA": "Scotland",
    "teamB": "Morocco",
    "city": "Boston",
    "country": "United States",
    "stadium": "Gillette Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 31,
    "date": "2026-06-19",
    "day": "Friday",
    "kickoffET": "23:00",
    "stage": "Group Stage",
    "group": "D",
    "teamA": "Türkiye",
    "teamB": "Paraguay",
    "city": "San Francisco Bay Area",
    "country": "United States",
    "stadium": "Levi's Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 32,
    "date": "2026-06-19",
    "day": "Friday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "D",
    "teamA": "USA",
    "teamB": "Australia",
    "city": "Seattle",
    "country": "United States",
    "stadium": "Lumen Field",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 33,
    "date": "2026-06-20",
    "day": "Saturday",
    "kickoffET": "16:00",
    "stage": "Group Stage",
    "group": "E",
    "teamA": "Germany",
    "teamB": "Côte d’Ivoire",
    "city": "Toronto",
    "country": "Canada",
    "stadium": "BMO Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 34,
    "date": "2026-06-20",
    "day": "Saturday",
    "kickoffET": "20:00",
    "stage": "Group Stage",
    "group": "E",
    "teamA": "Ecuador",
    "teamB": "Curaçao",
    "city": "Kansas City",
    "country": "United States",
    "stadium": "Arrowhead Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 35,
    "date": "2026-06-20",
    "day": "Saturday",
    "kickoffET": "13:00",
    "stage": "Group Stage",
    "group": "F",
    "teamA": "Netherlands",
    "teamB": "Sweden",
    "city": "Vancouver",
    "country": "Canada",
    "stadium": "BC Place",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 36,
    "date": "2026-06-21",
    "day": "Sunday",
    "kickoffET": "00:00",
    "stage": "Group Stage",
    "group": "F",
    "teamA": "Tunisia",
    "teamB": "Japan",
    "city": "Monterrey",
    "country": "Mexico",
    "stadium": "Estadio BBVA",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 37,
    "date": "2026-06-21",
    "day": "Sunday",
    "kickoffET": "18:00",
    "stage": "Group Stage",
    "group": "H",
    "teamA": "Uruguay",
    "teamB": "Cabo Verde",
    "city": "Miami",
    "country": "United States",
    "stadium": "Hard Rock Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 38,
    "date": "2026-06-21",
    "day": "Sunday",
    "kickoffET": "12:00",
    "stage": "Group Stage",
    "group": "H",
    "teamA": "Spain",
    "teamB": "Saudi Arabia",
    "city": "Atlanta",
    "country": "United States",
    "stadium": "Mercedes-Benz Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 39,
    "date": "2026-06-21",
    "day": "Sunday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "G",
    "teamA": "Belgium",
    "teamB": "IR Iran",
    "city": "Los Angeles",
    "country": "United States",
    "stadium": "SoFi Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 40,
    "date": "2026-06-21",
    "day": "Sunday",
    "kickoffET": "21:00",
    "stage": "Group Stage",
    "group": "G",
    "teamA": "New Zealand",
    "teamB": "Egypt",
    "city": "Toronto",
    "country": "Canada",
    "stadium": "BMO Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 41,
    "date": "2026-06-22",
    "day": "Monday",
    "kickoffET": "20:00",
    "stage": "Group Stage",
    "group": "I",
    "teamA": "Norway",
    "teamB": "Senegal",
    "city": "New York New Jersey",
    "country": "United States",
    "stadium": "MetLife Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 42,
    "date": "2026-06-22",
    "day": "Monday",
    "kickoffET": "17:00",
    "stage": "Group Stage",
    "group": "I",
    "teamA": "France",
    "teamB": "Iraq",
    "city": "Philadelphia",
    "country": "United States",
    "stadium": "Lincoln Financial Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 43,
    "date": "2026-06-22",
    "day": "Monday",
    "kickoffET": "13:00",
    "stage": "Group Stage",
    "group": "J",
    "teamA": "Argentina",
    "teamB": "Austria",
    "city": "Dallas",
    "country": "United States",
    "stadium": "AT&T Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 44,
    "date": "2026-06-22",
    "day": "Monday",
    "kickoffET": "23:00",
    "stage": "Group Stage",
    "group": "J",
    "teamA": "Jordan",
    "teamB": "Algeria",
    "city": "San Francisco Bay Area",
    "country": "United States",
    "stadium": "Levi's Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 45,
    "date": "2026-06-23",
    "day": "Tuesday",
    "kickoffET": "16:00",
    "stage": "Group Stage",
    "group": "L",
    "teamA": "England",
    "teamB": "Ghana",
    "city": "Boston",
    "country": "United States",
    "stadium": "Gillette Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 46,
    "date": "2026-06-23",
    "day": "Tuesday",
    "kickoffET": "19:00",
    "stage": "Group Stage",
    "group": "L",
    "teamA": "Panama",
    "teamB": "Croatia",
    "city": "Toronto",
    "country": "Canada",
    "stadium": "BMO Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 47,
    "date": "2026-06-23",
    "day": "Tuesday",
    "kickoffET": "13:00",
    "stage": "Group Stage",
    "group": "K",
    "teamA": "Portugal",
    "teamB": "Uzbekistan",
    "city": "Houston",
    "country": "United States",
    "stadium": "NRG Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 48,
    "date": "2026-06-23",
    "day": "Tuesday",
    "kickoffET": "22:00",
    "stage": "Group Stage",
    "group": "K",
    "teamA": "Colombia",
    "teamB": "Congo DR",
    "city": "Guadalajara",
    "country": "Mexico",
    "stadium": "Estadio Akron",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 49,
    "date": "2026-06-24",
    "day": "Wednesday",
    "kickoffET": "18:00",
    "stage": "Group Stage",
    "group": "C",
    "teamA": "Scotland",
    "teamB": "Brazil",
    "city": "Miami",
    "country": "United States",
    "stadium": "Hard Rock Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 50,
    "date": "2026-06-24",
    "day": "Wednesday",
    "kickoffET": "18:00",
    "stage": "Group Stage",
    "group": "C",
    "teamA": "Morocco",
    "teamB": "Haiti",
    "city": "Atlanta",
    "country": "United States",
    "stadium": "Mercedes-Benz Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 51,
    "date": "2026-06-24",
    "day": "Wednesday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "B",
    "teamA": "Switzerland",
    "teamB": "Canada",
    "city": "Vancouver",
    "country": "Canada",
    "stadium": "BC Place",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 52,
    "date": "2026-06-24",
    "day": "Wednesday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "B",
    "teamA": "Bosnia and Herzegovina",
    "teamB": "Qatar",
    "city": "Seattle",
    "country": "United States",
    "stadium": "Lumen Field",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 53,
    "date": "2026-06-24",
    "day": "Wednesday",
    "kickoffET": "21:00",
    "stage": "Group Stage",
    "group": "A",
    "teamA": "Czechia",
    "teamB": "Mexico",
    "city": "Mexico City",
    "country": "Mexico",
    "stadium": "Estadio Azteca",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 54,
    "date": "2026-06-24",
    "day": "Wednesday",
    "kickoffET": "21:00",
    "stage": "Group Stage",
    "group": "A",
    "teamA": "South Africa",
    "teamB": "Korea Republic",
    "city": "Monterrey",
    "country": "Mexico",
    "stadium": "Estadio BBVA",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 55,
    "date": "2026-06-25",
    "day": "Thursday",
    "kickoffET": "16:00",
    "stage": "Group Stage",
    "group": "E",
    "teamA": "Curaçao",
    "teamB": "Côte d’Ivoire",
    "city": "Philadelphia",
    "country": "United States",
    "stadium": "Lincoln Financial Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 56,
    "date": "2026-06-25",
    "day": "Thursday",
    "kickoffET": "16:00",
    "stage": "Group Stage",
    "group": "E",
    "teamA": "Ecuador",
    "teamB": "Germany",
    "city": "New York New Jersey",
    "country": "United States",
    "stadium": "MetLife Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 57,
    "date": "2026-06-25",
    "day": "Thursday",
    "kickoffET": "19:00",
    "stage": "Group Stage",
    "group": "F",
    "teamA": "Japan",
    "teamB": "Sweden",
    "city": "Dallas",
    "country": "United States",
    "stadium": "AT&T Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 58,
    "date": "2026-06-25",
    "day": "Thursday",
    "kickoffET": "19:00",
    "stage": "Group Stage",
    "group": "F",
    "teamA": "Tunisia",
    "teamB": "Netherlands",
    "city": "Kansas City",
    "country": "United States",
    "stadium": "Arrowhead Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 59,
    "date": "2026-06-25",
    "day": "Thursday",
    "kickoffET": "22:00",
    "stage": "Group Stage",
    "group": "D",
    "teamA": "Türkiye",
    "teamB": "USA",
    "city": "Los Angeles",
    "country": "United States",
    "stadium": "SoFi Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 60,
    "date": "2026-06-25",
    "day": "Thursday",
    "kickoffET": "22:00",
    "stage": "Group Stage",
    "group": "D",
    "teamA": "Paraguay",
    "teamB": "Australia",
    "city": "San Francisco Bay Area",
    "country": "United States",
    "stadium": "Levi's Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 61,
    "date": "2026-06-26",
    "day": "Friday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "I",
    "teamA": "Norway",
    "teamB": "France",
    "city": "Boston",
    "country": "United States",
    "stadium": "Gillette Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 62,
    "date": "2026-06-26",
    "day": "Friday",
    "kickoffET": "15:00",
    "stage": "Group Stage",
    "group": "I",
    "teamA": "Senegal",
    "teamB": "Iraq",
    "city": "Toronto",
    "country": "Canada",
    "stadium": "BMO Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 63,
    "date": "2026-06-26",
    "day": "Friday",
    "kickoffET": "23:00",
    "stage": "Group Stage",
    "group": "G",
    "teamA": "Egypt",
    "teamB": "IR Iran",
    "city": "Seattle",
    "country": "United States",
    "stadium": "Lumen Field",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 64,
    "date": "2026-06-26",
    "day": "Friday",
    "kickoffET": "23:00",
    "stage": "Group Stage",
    "group": "G",
    "teamA": "New Zealand",
    "teamB": "Belgium",
    "city": "Vancouver",
    "country": "Canada",
    "stadium": "BC Place",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 65,
    "date": "2026-06-26",
    "day": "Friday",
    "kickoffET": "20:00",
    "stage": "Group Stage",
    "group": "H",
    "teamA": "Cabo Verde",
    "teamB": "Saudi Arabia",
    "city": "Houston",
    "country": "United States",
    "stadium": "NRG Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 66,
    "date": "2026-06-26",
    "day": "Friday",
    "kickoffET": "20:00",
    "stage": "Group Stage",
    "group": "H",
    "teamA": "Uruguay",
    "teamB": "Spain",
    "city": "Guadalajara",
    "country": "Mexico",
    "stadium": "Estadio Akron",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 67,
    "date": "2026-06-27",
    "day": "Saturday",
    "kickoffET": "17:00",
    "stage": "Group Stage",
    "group": "L",
    "teamA": "Panama",
    "teamB": "England",
    "city": "New York New Jersey",
    "country": "United States",
    "stadium": "MetLife Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 68,
    "date": "2026-06-27",
    "day": "Saturday",
    "kickoffET": "17:00",
    "stage": "Group Stage",
    "group": "L",
    "teamA": "Croatia",
    "teamB": "Ghana",
    "city": "Philadelphia",
    "country": "United States",
    "stadium": "Lincoln Financial Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 69,
    "date": "2026-06-27",
    "day": "Saturday",
    "kickoffET": "22:00",
    "stage": "Group Stage",
    "group": "J",
    "teamA": "Algeria",
    "teamB": "Austria",
    "city": "Kansas City",
    "country": "United States",
    "stadium": "Arrowhead Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 70,
    "date": "2026-06-27",
    "day": "Saturday",
    "kickoffET": "22:00",
    "stage": "Group Stage",
    "group": "J",
    "teamA": "Jordan",
    "teamB": "Argentina",
    "city": "Dallas",
    "country": "United States",
    "stadium": "AT&T Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 71,
    "date": "2026-06-27",
    "day": "Saturday",
    "kickoffET": "19:30",
    "stage": "Group Stage",
    "group": "K",
    "teamA": "Colombia",
    "teamB": "Portugal",
    "city": "Miami",
    "country": "United States",
    "stadium": "Hard Rock Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 72,
    "date": "2026-06-27",
    "day": "Saturday",
    "kickoffET": "19:30",
    "stage": "Group Stage",
    "group": "K",
    "teamA": "Congo DR",
    "teamB": "Uzbekistan",
    "city": "Atlanta",
    "country": "United States",
    "stadium": "Mercedes-Benz Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 73,
    "date": "2026-06-28",
    "day": "Sunday",
    "kickoffET": "15:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "2A",
    "teamB": "2B",
    "city": "Los Angeles",
    "country": "United States",
    "stadium": "SoFi Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 74,
    "date": "2026-06-28",
    "day": "Sunday",
    "kickoffET": "16:30",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1E",
    "teamB": "3ABCDF",
    "city": "Boston",
    "country": "United States",
    "stadium": "Gillette Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 75,
    "date": "2026-06-29",
    "day": "Monday",
    "kickoffET": "21:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1F",
    "teamB": "2C",
    "city": "Monterrey",
    "country": "Mexico",
    "stadium": "Estadio BBVA",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 76,
    "date": "2026-06-29",
    "day": "Monday",
    "kickoffET": "13:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1C",
    "teamB": "2F",
    "city": "Houston",
    "country": "United States",
    "stadium": "NRG Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 77,
    "date": "2026-07-03",
    "day": "Friday",
    "kickoffET": "17:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1I",
    "teamB": "3CDFGH",
    "city": "New York New Jersey",
    "country": "United States",
    "stadium": "MetLife Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 78,
    "date": "2026-06-29",
    "day": "Monday",
    "kickoffET": "13:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "2E",
    "teamB": "2I",
    "city": "Dallas",
    "country": "United States",
    "stadium": "AT&T Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 79,
    "date": "2026-06-30",
    "day": "Tuesday",
    "kickoffET": "21:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1A",
    "teamB": "3CEFHI",
    "city": "Mexico City",
    "country": "Mexico",
    "stadium": "Estadio Azteca",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 80,
    "date": "2026-07-01",
    "day": "Wednesday",
    "kickoffET": "12:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1L",
    "teamB": "3EHIJK",
    "city": "Atlanta",
    "country": "United States",
    "stadium": "Mercedes-Benz Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 81,
    "date": "2026-06-30",
    "day": "Tuesday",
    "kickoffET": "20:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1D",
    "teamB": "3BEFIJ",
    "city": "San Francisco Bay Area",
    "country": "United States",
    "stadium": "Levi's Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 82,
    "date": "2026-06-30",
    "day": "Tuesday",
    "kickoffET": "16:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1G",
    "teamB": "3AEHIJ",
    "city": "Seattle",
    "country": "United States",
    "stadium": "Lumen Field",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 83,
    "date": "2026-07-02",
    "day": "Thursday",
    "kickoffET": "19:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "2K",
    "teamB": "2L",
    "city": "Toronto",
    "country": "Canada",
    "stadium": "BMO Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 84,
    "date": "2026-07-01",
    "day": "Wednesday",
    "kickoffET": "15:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1H",
    "teamB": "2J",
    "city": "Los Angeles",
    "country": "United States",
    "stadium": "SoFi Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 85,
    "date": "2026-06-28",
    "day": "Sunday",
    "kickoffET": "23:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1B",
    "teamB": "3EFGIJ",
    "city": "Vancouver",
    "country": "Canada",
    "stadium": "BC Place",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 86,
    "date": "2026-07-02",
    "day": "Thursday",
    "kickoffET": "18:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1J",
    "teamB": "2H",
    "city": "Miami",
    "country": "United States",
    "stadium": "Hard Rock Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 87,
    "date": "2026-07-01",
    "day": "Wednesday",
    "kickoffET": "21:30",
    "stage": "Round of 32",
    "group": null,
    "teamA": "1K",
    "teamB": "3DEIJL",
    "city": "Kansas City",
    "country": "United States",
    "stadium": "Arrowhead Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 88,
    "date": "2026-07-02",
    "day": "Thursday",
    "kickoffET": "14:00",
    "stage": "Round of 32",
    "group": null,
    "teamA": "2D",
    "teamB": "2G",
    "city": "Dallas",
    "country": "United States",
    "stadium": "AT&T Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 89,
    "date": "2026-07-04",
    "day": "Saturday",
    "kickoffET": "17:00",
    "stage": "Round of 16",
    "group": null,
    "teamA": "W74",
    "teamB": "W77",
    "city": "Philadelphia",
    "country": "United States",
    "stadium": "Lincoln Financial Field",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 90,
    "date": "2026-07-05",
    "day": "Sunday",
    "kickoffET": "13:00",
    "stage": "Round of 16",
    "group": null,
    "teamA": "W73",
    "teamB": "W75",
    "city": "Houston",
    "country": "United States",
    "stadium": "NRG Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 91,
    "date": "2026-07-05",
    "day": "Sunday",
    "kickoffET": "16:00",
    "stage": "Round of 16",
    "group": null,
    "teamA": "W76",
    "teamB": "W78",
    "city": "New York New Jersey",
    "country": "United States",
    "stadium": "MetLife Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 92,
    "date": "2026-07-05",
    "day": "Sunday",
    "kickoffET": "20:00",
    "stage": "Round of 16",
    "group": null,
    "teamA": "W79",
    "teamB": "W80",
    "city": "Mexico City",
    "country": "Mexico",
    "stadium": "Estadio Azteca",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 93,
    "date": "2026-07-06",
    "day": "Monday",
    "kickoffET": "15:00",
    "stage": "Round of 16",
    "group": null,
    "teamA": "W83",
    "teamB": "W84",
    "city": "Dallas",
    "country": "United States",
    "stadium": "AT&T Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 94,
    "date": "2026-07-06",
    "day": "Monday",
    "kickoffET": "20:00",
    "stage": "Round of 16",
    "group": null,
    "teamA": "W81",
    "teamB": "W82",
    "city": "Seattle",
    "country": "United States",
    "stadium": "Lumen Field",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 95,
    "date": "2026-07-07",
    "day": "Tuesday",
    "kickoffET": "12:00",
    "stage": "Round of 16",
    "group": null,
    "teamA": "W86",
    "teamB": "W88",
    "city": "Atlanta",
    "country": "United States",
    "stadium": "Mercedes-Benz Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 96,
    "date": "2026-07-07",
    "day": "Tuesday",
    "kickoffET": "16:00",
    "stage": "Round of 16",
    "group": null,
    "teamA": "W85",
    "teamB": "W87",
    "city": "Vancouver",
    "country": "Canada",
    "stadium": "BC Place",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 97,
    "date": "2026-07-09",
    "day": "Thursday",
    "kickoffET": "16:00",
    "stage": "Quarter-final",
    "group": null,
    "teamA": "W89",
    "teamB": "W90",
    "city": "Boston",
    "country": "United States",
    "stadium": "Gillette Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 98,
    "date": "2026-07-10",
    "day": "Friday",
    "kickoffET": "15:00",
    "stage": "Quarter-final",
    "group": null,
    "teamA": "W93",
    "teamB": "W94",
    "city": "Los Angeles",
    "country": "United States",
    "stadium": "SoFi Stadium",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 99,
    "date": "2026-07-10",
    "day": "Friday",
    "kickoffET": "17:00",
    "stage": "Quarter-final",
    "group": null,
    "teamA": "W91",
    "teamB": "W92",
    "city": "Miami",
    "country": "United States",
    "stadium": "Hard Rock Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 100,
    "date": "2026-07-11",
    "day": "Saturday",
    "kickoffET": "21:00",
    "stage": "Quarter-final",
    "group": null,
    "teamA": "W95",
    "teamB": "W96",
    "city": "Vancouver",
    "country": "Canada",
    "stadium": "BC Place",
    "region": "Western Region",
    "result": null
  },
  {
    "matchNo": 101,
    "date": "2026-07-14",
    "day": "Tuesday",
    "kickoffET": "15:00",
    "stage": "Semi-final",
    "group": null,
    "teamA": "W97",
    "teamB": "W98",
    "city": "Dallas",
    "country": "United States",
    "stadium": "AT&T Stadium",
    "region": "Central Region",
    "result": null
  },
  {
    "matchNo": 102,
    "date": "2026-07-15",
    "day": "Wednesday",
    "kickoffET": "15:00",
    "stage": "Semi-final",
    "group": null,
    "teamA": "W99",
    "teamB": "W100",
    "city": "Atlanta",
    "country": "United States",
    "stadium": "Mercedes-Benz Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 103,
    "date": "2026-07-18",
    "day": "Saturday",
    "kickoffET": "17:00",
    "stage": "Bronze final",
    "group": null,
    "teamA": "Loser Match 101",
    "teamB": "Loser Match 102",
    "city": "Miami",
    "country": "United States",
    "stadium": "Hard Rock Stadium",
    "region": "Eastern Region",
    "result": null
  },
  {
    "matchNo": 104,
    "date": "2026-07-19",
    "day": "Sunday",
    "kickoffET": "15:00",
    "stage": "Final",
    "group": null,
    "teamA": "Winner Match 101",
    "teamB": "Winner Match 102",
    "city": "New York New Jersey",
    "country": "United States",
    "stadium": "MetLife Stadium",
    "region": "Eastern Region",
    "result": null
  }
];

export const scheduleSummary = {
  "totalMatches": 104,
  "stageCounts": [
    {
      "stage": "Group Stage",
      "matches": 72
    },
    {
      "stage": "Round of 32",
      "matches": 16
    },
    {
      "stage": "Round of 16",
      "matches": 8
    },
    {
      "stage": "Quarter-final",
      "matches": 4
    },
    {
      "stage": "Semi-final",
      "matches": 2
    },
    {
      "stage": "Bronze final",
      "matches": 1
    },
    {
      "stage": "Final",
      "matches": 1
    }
  ],
  "cityCounts": [
    {
      "city": "Atlanta",
      "country": "United States",
      "stadium": "Mercedes-Benz Stadium",
      "region": "Eastern Region",
      "matches": 8
    },
    {
      "city": "Boston",
      "country": "United States",
      "stadium": "Gillette Stadium",
      "region": "Eastern Region",
      "matches": 7
    },
    {
      "city": "Dallas",
      "country": "United States",
      "stadium": "AT&T Stadium",
      "region": "Central Region",
      "matches": 9
    },
    {
      "city": "Guadalajara",
      "country": "Mexico",
      "stadium": "Estadio Akron",
      "region": "Central Region",
      "matches": 4
    },
    {
      "city": "Houston",
      "country": "United States",
      "stadium": "NRG Stadium",
      "region": "Central Region",
      "matches": 6
    },
    {
      "city": "Kansas City",
      "country": "United States",
      "stadium": "Arrowhead Stadium",
      "region": "Central Region",
      "matches": 5
    },
    {
      "city": "Los Angeles",
      "country": "United States",
      "stadium": "SoFi Stadium",
      "region": "Western Region",
      "matches": 8
    },
    {
      "city": "Mexico City",
      "country": "Mexico",
      "stadium": "Estadio Azteca",
      "region": "Central Region",
      "matches": 5
    },
    {
      "city": "Miami",
      "country": "United States",
      "stadium": "Hard Rock Stadium",
      "region": "Eastern Region",
      "matches": 7
    },
    {
      "city": "Monterrey",
      "country": "Mexico",
      "stadium": "Estadio BBVA",
      "region": "Central Region",
      "matches": 4
    },
    {
      "city": "New York New Jersey",
      "country": "United States",
      "stadium": "MetLife Stadium",
      "region": "Eastern Region",
      "matches": 8
    },
    {
      "city": "Philadelphia",
      "country": "United States",
      "stadium": "Lincoln Financial Field",
      "region": "Eastern Region",
      "matches": 6
    },
    {
      "city": "San Francisco Bay Area",
      "country": "United States",
      "stadium": "Levi's Stadium",
      "region": "Western Region",
      "matches": 6
    },
    {
      "city": "Seattle",
      "country": "United States",
      "stadium": "Lumen Field",
      "region": "Western Region",
      "matches": 6
    },
    {
      "city": "Toronto",
      "country": "Canada",
      "stadium": "BMO Field",
      "region": "Eastern Region",
      "matches": 7
    },
    {
      "city": "Vancouver",
      "country": "Canada",
      "stadium": "BC Place",
      "region": "Western Region",
      "matches": 8
    }
  ]
};
